import { useEffect, useState } from "react";
import Table, { Column } from "../common/table";
import { Monitor } from "../../types/Monitor";
import MonitorService from "../../services/monitor.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MonitorsPage() {
    const { t } = useTranslation();

    const columns: Column<Monitor>[] = [
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="hide-on-mobile bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('monitors.name')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="hide-on-mobile whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.name}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('monitors.description')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    {row.description}
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="hide-on-mobile bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('monitors.muted')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="hide-on-mobile whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    <input
                        type="checkbox"
                        checked={row.muted}
                        onClick={(e) => e.stopPropagation()}
                        className="mt-1 w-5 h-5 rounded-md border border-gray-300"
                        onChange={() => handleCheckboxClick(row._id, 'muted', !row.muted)}
                    />
                </td>
            ),
        },
        {
            renderHeader: (i: number) => (
                <th
                    key={i}
                    className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
                    scope="col"
                >
                    {t('monitors.disabled')}
                </th>
            ),
            renderRow: (row, _rowI, colI) => (
                <td key={colI} className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500">
                    <input
                        type="checkbox"
                        checked={row.disabled}
                        onClick={(e) => e.stopPropagation()}
                        className="mt-1 w-5 h-5 rounded-md border border-gray-300"
                        onChange={() => handleCheckboxClick(row._id, 'disabled', !row.disabled)}
                    />
                </td>
            ),
        }
    ];

    const [rows, setRows] = useState<Monitor[]>([]);
    const navigate = useNavigate();

    const handleRowClick = (monitorId: string) => {
        navigate(`/monitors/${monitorId}`);
    };

    const handleAdd = () => {
        navigate('/monitors/add');
    };

    const handleCheckboxClick = (monitorId: string, field: 'muted' | 'disabled', value: boolean) => {
        MonitorService.updateMonitor(monitorId, { [field]: value }).then(response => {
            response.json().then(data => {
                setRows(rows.map(row => row._id === monitorId ? data : row));
            });
        });
    }

    const fetchData = async () => {
        const response = await MonitorService.getMonitors();
        const data = await response.json();
        setRows(data);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Table
            columns={columns}
            rows={rows}
            title={t('monitors.monitors')}
            showAddButton={true}
            onAdd={handleAdd}
            currentPage={1}
            pageSize={1}
            totalRows={1}
            onRowClick={row => handleRowClick(row._id)}
        />
    );
}
